import type { Country } from '@base/types'
import { COUNTRIES } from '@develit-io/general-codes'

const countries: Country[] = [
  ...COUNTRIES,
].filter(country => !('sanctions' in country) || !country.sanctions)

export default countries
